import { useTranslations } from 'next-intl';
import { Dialog, DialogContent, DialogTitle, Typography, Zoom, TextField, Box } from '@mui/material';
import { Button } from './Button';
import { FC, useEffect, useState } from 'react';
import LazyImage from '../components/LazyImage/index';
import { styled } from './styles/stitches.styles';

interface Props {
  isOpened: boolean;
  onClose: () => void;
  onSubmit: (firstname: string, lastname: string) => Promise<void>;
  initialValues: { firstname: string; lastname: string };
  className?: string;
}

const NAME_MAX_LENGTH = 10;
const LASTNAME_MAX_LENGTH = 15;

let ChangeNameModal: FC<Props> = ({ isOpened, onClose, onSubmit, initialValues, className }) => {
  const t = useTranslations();
  const [firstname, setFirstname] = useState(initialValues.firstname || '');
  const [lastname, setLastname] = useState(initialValues.lastname || '');
  const [isLoading, setIsLoading] = useState(false);
  const [isEditingFirstname, setIsEditingFirstname] = useState(!initialValues.firstname);
  const [isEditingLastname, setIsEditingLastname] = useState(!initialValues.lastname);

  useEffect(() => {
    setFirstname(initialValues.firstname || '');
    setLastname(initialValues.lastname || '');
    setIsEditingFirstname(!initialValues.firstname);
    setIsEditingLastname(!initialValues.lastname);
  }, [initialValues.firstname, initialValues.lastname]);

  const prepareSubmit = async () => {
    if (isLoading) {
      return;
    }

    setIsLoading(true);
    setIsEditingFirstname(false);
    setIsEditingLastname(false);

    await onSubmit(firstname, lastname);

    setIsLoading(false);
  };
  console.log(initialValues);

  return (
    <Dialog
      className={className}
      aria-labelledby='entrance-dialog'
      open={isOpened}
      maxWidth='sm'
      fullWidth
      scroll='body'
      onClose={onClose}
    >
      <Zoom in={isOpened}>
        <DialogContent sx={{ background: '#1C1929' }}>
          <DialogTitle
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              alignItems: 'center',
              background: '#1C1929',
              p: 0,
              mb: 3
            }}
          >
            <Typography
              variant='h6'
              sx={{
                color: 'white',
                marginBottom: { sm: 0 },
                textAlign: 'center'
              }}
            >
              {t('header.dropdown.enter')}
              <br />
              {t('header.dropdown.nameLastname')}
            </Typography>
            <Box sx={{ position: 'absolute', top: 20, right: 24, cursor: 'pointer' }} onClick={onClose}>
              <LazyImage src={'/images/icons/landing/close.svg'} alt='close' width={24} height={24} />
            </Box>
          </DialogTitle>
          <div className='change_name_wrapper'>
            <div className='change_name_wrapper_input'>
              <TextField
                value={firstname}
                onChange={({ target }) => (target.value.length > NAME_MAX_LENGTH ? null : setFirstname(target.value))}
                placeholder='Имя'
                variant='filled'
                disabled={!isEditingFirstname}
                sx={{ color: '#FFF !important' }}
              />
              <button
                className='change_name_wrapper_edit'
                onClick={() => setIsEditingFirstname(prevState => !prevState)}
              >
                <LazyImage src='/images/icons/landing/edit.svg' alt='' />
              </button>
            </div>
            <div className='change_name_wrapper_input'>
              <TextField
                value={lastname}
                onChange={({ target }) =>
                  target.value.length > LASTNAME_MAX_LENGTH ? null : setLastname(target.value)
                }
                placeholder='Фамилия'
                variant='filled'
                disabled={!isEditingLastname}
                style={{ color: '#FFF' }}
              />
              <button
                className='change_name_wrapper_edit'
                onClick={() => setIsEditingLastname(prevState => !prevState)}
              >
                <LazyImage src='/images/icons/landing/edit.svg' alt='' />
              </button>
            </div>
            <div className='change_name_wrapper_submit'>
              <Button
                onClick={prepareSubmit}
                sx={{
                  color: 'white',
                  cursor: 'pointer',
                  padding: '5px 15px',
                  borderRadius: 15,
                  background: '#ffffff1A',
                  margin: '0 auto'
                }}
              >
                {t('header.dropdown.save')}
              </Button>
            </div>
          </div>
        </DialogContent>
      </Zoom>
    </Dialog>
  );
};

ChangeNameModal = styled(ChangeNameModal, {
  '& .change_name_wrapper': {
    display: 'grid',
    gap: '16px',
    width: '100%'
  },
  '& .change_name_wrapper_input': {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    width: '100%',

    '& > .MuiFormControl-root': {
      width: '100%',

      '& .MuiFilledInput-input.Mui-disabled': {
        '-webkit-text-fill-color': 'unset !important',
        opacity: 0.6
      }
    }
  },
  '& .change_name_wrapper_submit': {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '16px'
  },
  '& .change_name_wrapper_edit': {
    backgroundColor: 'transparent',
    border: 'none'
  }
});

export { ChangeNameModal };
